import { API } from 'aws-amplify';
import { IData } from 'src/types/org/common/dataSchema';
import { IDIRequest } from 'src/types/org/di/diRequestSchema';
import { processResponse } from 'src/utils/api';

export const submitDIUpdateForm = async (formData: any): Promise<IDIRequest<IData>> => {
  const data = await API.post('AiFormRequest', '/save?key=submitUpdateRequest', {
    body: formData,
  }).then(processResponse);
  return data;
};
